import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import client, { apiCall } from '../../api/client';
import DataTable from '../../components/DataTable';
import StatusBadge from '../../components/StatusBadge';
import Loader from '../../components/Loader';

export default function Billing() {
  const [history, setHistory] = useState([]);
  const [plans, setPlans] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      apiCall(client.get('/credit_plan/history')).then(setHistory),
      apiCall(client.get('/credit_plan/get_list')).then(setPlans).catch(() => setPlans([])),
    ]).catch((e) => setError(e.message)).finally(() => setLoading(false));
  }, []);

  const planName = (planId) => plans.find((p) => p.uniqueId === planId)?.name || planId;

  const columns = [
    { key: 'planId', label: 'Plan', render: (row) => planName(row.planId) },
    { key: 'startDate', label: 'Start', render: (row) => new Date(row.startDate).toLocaleDateString() },
    { key: 'expiryDate', label: 'Expiry', render: (row) => new Date(row.expiryDate).toLocaleDateString() },
    { key: 'status', label: 'Status', render: (row) => <StatusBadge value={row.status} /> },
  ];

  return (
    <div>
      <div className="card-header">
        <h1>Billing &amp; Plans</h1>
        <Link to="/pricing" className="btn btn-primary btn-sm">Change plan</Link>
      </div>
      {error && <div className="form-error">{error}</div>}
      <div className="card">
        <div className="card-header"><h3>Subscription history</h3></div>
        {loading ? (
          <Loader label="Loading billing history..." />
        ) : (
          <DataTable columns={columns} rows={history} emptyMessage="No subscriptions yet." />
        )}
      </div>
    </div>
  );
}
